import { render, staticRenderFns } from "./TheHelpPage.vue?vue&type=template&id=4a7c7040&"
import script from "./TheHelpPage.vue?vue&type=script&lang=ts&"
export * from "./TheHelpPage.vue?vue&type=script&lang=ts&"
import style0 from "./TheHelpPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
